import Cookies from "js-cookie";
import { isLocalHost } from "../agent";

export const REFRESH_TOKEN_KEY = "REFRESHTOKENKEY";

export function saveRefreshToken(userId: string, refreshToken: string) {
  if (typeof window !== "undefined") {
    try {
      Cookies.set(REFRESH_TOKEN_KEY, JSON.stringify({ userId, refreshToken }), {
        secure: !isLocalHost(),
        sameSite: 'None',
        expires: 365,
      });
    } catch (e) {}
  }
}

export function getRefreshToken(): {
  userId: string;
  refreshToken: string;
} | null {
  try {
    const data = Cookies.get(REFRESH_TOKEN_KEY);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
}

export function clear(): void {
  Cookies.remove(REFRESH_TOKEN_KEY);
}
